(() => {

    document.addEventListener('DOMContentLoaded', function () {

        let upcomingSessions = document.getElementById('upcoming-sessions');
        if (!upcomingSessions) {
            return;
        }

        function setupModal(id, appointmentGuid, action, hasFile) {
            let modal = document.getElementById(id);
            let actionButton = modal.getElementsByClassName('btn-action')[0];
            actionButton.removeEventListener('click', actionButtonClick);

            actionButton.dataset.appointmentGuid = appointmentGuid;
            if (action) {
                actionButton.dataset.action = action;
            }
            else {
                action = actionButton.dataset.action;
            }

            let declinePIP = document.getElementById('declinepip');
            let declineMessage = modal.getElementsByClassName('decline-message')[0];
            if (action == 'Declined' && hasFile) {
                declinePIP.parentElement.classList.remove('d-none');
                declineMessage.classList.add('d-none');
            }
            else if (action == 'Declined' && !hasFile) {
                declinePIP.parentElement.classList.add('d-none');
                declineMessage.classList.remove('d-none');
            }

            actionButton.addEventListener('click', actionButtonClick);
        }

        function actionButtonClick(evt) {
            let appointmentGuid = evt.target.dataset.appointmentGuid;
            let action = evt.target.dataset.action;
            let formData = new FormData();
            formData.append('AppointmentGuid', appointmentGuid);
            formData.append('Status', action);

            if (action == 'Declined') {
                let declinePIP = document.getElementById('declinepip');
                if (declinePIP && declinePIP.value) {
                    let val = declinePIP.value;
                    formData.append('DeclinePIP', val);
                }
                else {
                    let err = document.createElement('div');
                    err.innerText = 'Please provide a reason for declining.';
                    declinePIP.after(err);
                    evt.preventDefault();
                    return;
                }
                
            }


            fetch('/App/UpdateAppointmentStatus', {
                method: 'POST',
                body:formData
            }).then(() => {
                window.location.reload();
            });
        }
        window.setupModal = setupModal;
    })    
})();
